import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
// import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from './reducers';

/* const storeMiddleware =
  process.env.REACT_APP_NODE_CLIENT_ENV === 'production'
    ? applyMiddleware(thunk)
    : composeWithDevTools(applyMiddleware(thunk)); */
const storeMiddleware = applyMiddleware(thunk);
const store = createStore(rootReducer, storeMiddleware);

export default store;
